export const getReservationReasons = () => {
  return ['Accident', 'Mechanical Failure', 'Service', 'Other']
}
